import './progressNS.sass'

const ProgressNS = () => {
    return (
        <div className="progressNS--box">
            <div className="progressNS--wrap">
                <div className="progressNS--wrap-dot"></div>
                <div className="progressNS--wrap-dot"></div>
                <div className="progressNS--wrap-dot"></div>
                <div className="progressNS--wrap-dot"></div>
                <div className="progressNS--wrap-dot"></div>
                <div className="progressNS--wrap-dot"></div>
            </div>
        </div>
    )
}

export default ProgressNS
